import { Injectable } from '@angular/core';
import { GlobalTrackingService } from '../../../SGRE-shared/services/global-tracking.service';
import { StorageService } from '../../../SGRE-shared/services/storage.service';
import { AuthService, LanguageService } from '@spartacus/core';
import { take } from 'rxjs';
import { LoginStatus, pageData, PageReadyData, userData } from '../../../SGRE-shared/models/global-tracking.model';

@Injectable({
  providedIn: 'root'
})

export class CookiePolicyTrackingService {

  constructor(
    private globalAnalytic: GlobalTrackingService,
    private storageService: StorageService,
    private languageService: LanguageService,
    private authService: AuthService,
  ) { }

  sendPageReadyData(): void {
    let loginStatus: string;
    let language: string;
    this.languageService.getActive().subscribe((lang) => {
      language = lang;
    });
    this.authService.isUserLoggedIn()
      .pipe(take(1))
      .subscribe((flag: boolean) => loginStatus = (flag) ? LoginStatus.LOGGED_IN : LoginStatus.LOGGED_OUT);

    const page_data: pageData = {
      path: "/cookie-policy",
      title: "Cookie Policy",
      country: "WW",
      language: language || "",
      template: "PID-20-Cookie-Policy",
    }

    const user_data: userData = {
      loginStatus: loginStatus,
      role: this.storageService?.userRoles || '',
      company: this.storageService?.activeCart?.legalEntity?.company || '',
      companyId: this.storageService?.activeCart?.legalEntity?.companyId || ''
    }

    const pageReadyData: PageReadyData = {
      page: page_data,
      user: user_data
    };

    this.globalAnalytic.sendPageReadyData('page.ready', pageReadyData);
  }

  
}
